<template>
    <div>
        <h6>
            {{ $t('Component(InformationLevel):label') }}
            <InstructionInfoButton
                :instruction="$t('Component(InformationLevel):instruction')"
            />
        </h6>
        <span>{{ $t('Page(SendRequest):Component(Placeholder):information-on-' + informationLevel) }}</span>
    </div>
</template>

<script>
import InstructionInfoButton from "@core/components/common/instructions/InstructionInfoButton";
export default {
    components: {InstructionInfoButton},
    props: {
        informationLevel: {
            type: String,
            default: ''
        }
    }
}
</script>
